var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{staticClass:"my-5",attrs:{"width":3,"color":"primary-1","indeterminate":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }